(function($){

  $(function() {

    var items = $('.js--expand-click-area');

    if ( items[0] ) {

      items.on('click', function(event){
        $(this).find('.js--expand-click-area--target').get(0).click();
        event.stopPropagation();
      });

    }

  });

})(jQuery);